@if (vehicle) {
<app-blade-header [bladeIndex]="bladeIndex" (closeClicked)="closeRightBlade()">
  <ng-container title>
    <i class="icon fa-solid fa-bus-simple"></i>
    @if (title$ | async; as title) {
    {{title}}
    }
  </ng-container>

  @if (vehicle?.isElectric) {
  <ng-container class="tag">
    <app-battery-status-info [batteryStatusInfo]="vehicle?.stateOfCharge"></app-battery-status-info>
  </ng-container>
  }
</app-blade-header>
<app-tabs [tabs]="componentState?.tabs" [tabsInfo]="tabsInfo" [selectedTab]="componentState?.selectedTab"
  (changed)="changeTab($event)">
</app-tabs>
<div class="large-properties highlight-background">
  <div class="property">
    <div class="label"><i class="fa-solid fa-bus-simple"></i></div>
    <div class="value">{{vehicle?.inventoryNumberWithoutPrefix}}</div>
  </div>
  <div class="property">
    <div class="label"><i class="fas fa-circle-notch"></i> {{'Block' | translate}}</div>
    <div class="value">{{vehicle?.blockNumber}}</div>
  </div>
  <div class="property">
    <div class="label"><i class="fas fa-route"></i> {{'Route' | translate}}</div>
    <div class="value">{{vehicle?.routeNumber}}</div>
  </div>
  <div class="property">
    <div class="label"><i class="fas fa-code-branch"></i> {{'Trip' | translate}}</div>
    <div class="value">{{vehicle?.tripNumber}}</div>
  </div>
</div>
<mat-divider></mat-divider>
@if (componentState?.selectedTab === 'overview') {
@if (blockActivites && blockActivites.length > 0) {
<div>
  <app-vehicle-block-info [showCurrentAndNearestFuture]="true" [vehicleBlockActivities]="blockActivites"
    [vehicle]="vehicle" [drillInOutlet]="drillInOutlet"></app-vehicle-block-info>
  <mat-divider></mat-divider>
</div>
}

<!-- SignOn Warnings (feature toggled) -->
@for (signOnWarning of signOnWarnings; track trackByIndex($index, signOnWarning)) {
<app-signon-warning [warning]="signOnWarning" [inventoryNumber]="vehicle?.inventoryNumber"
  [routeNumber]="signOnWarning?.metadata?.routeName" [tripNumber]="signOnWarning?.metadata?.tripNumber"
  [hastusRegion]="signOnWarning?.metadata?.hastusRegion" [trafficDate]="signOnWarning?.metadata?.trafficDate">
</app-signon-warning>
<mat-divider></mat-divider>
}
<!-- Confirmable Warnings (will not have signOn warnings if feature toggle on) -->
@for (confirmWarning of confirmableWarnings; track trackByIndex($index, confirmWarning)) {
<app-restore-warning [warning]="confirmWarning" [inventoryNumber]="vehicle?.inventoryNumber">
</app-restore-warning>
}
<div class="tab overview-tab">
  <div class="section">
    <div class="label-tiny">{{'Warnings' | translate}}</div>
    <div class="traffic-deviation-buttons">
      @if (isTrafficDeviationEnabled) {
            <button 
              type="button" 
              class="btn-report-delay" 
              [disabled]="(vehicleActivity$ | async) == undefined"
        (click)="openTrafficDeviation()">
        {{ 'New deviation' | translate }}
      </button>
      }
      @if (isTrafficDeviationEnabled && (isConnectionFlow$ | async) === true) {
      <button type="button" class="btn-report-delay" (click)="addConnection()">
        {{ 'Choose connection' | translate }}
      </button>
      }
    </div>
  </div>

  @if (vehicle?.warnings?.length > 0 || vehicle?.confirmedWarnings?.length > 0) {
  <div class="warning-list">
    @for (warning of vehicle?.warnings; track trackByIndex($index, warning)) {
    <div class="warning-list-items">
      <mat-divider></mat-divider>
      <div class="warning-list-item">
        <div class="warning-list-item-icon">
          <app-warning-icon [messageType]="warning.messageType"></app-warning-icon>
        </div>
        <div class="warning-text-wrapper d-flex flex-column">
          <div class="warning-time">{{warning?.measuredAt | amTimeAgo}}</div>
          <div class="warning-text">{{ warning | formatWarningMessage }}</div>
        </div>
      </div>
    </div>
    }

    @for (warning of vehicle?.confirmedWarnings; track trackByIndex($index, warning)) {
    <div class="warning-list-items">
      <mat-divider></mat-divider>
      <div class="warning-list-item confirmed">
        <div class="warning-list-item-icon">
          <app-warning-icon [messageType]="warning.messageType"></app-warning-icon>
        </div>
        <div class="warning-text-wrapper d-flex flex-column">
          <div class="warning-time">{{warning?.confirmedAt | date:'yyyy-MM-dd HH:mm'}}</div>
          <div class="warning-text" [matTooltip]="warning | formatWarningMessage">{{'Confirmed' |
            translate}}:{{warning?.comment}}</div>
        </div>
      </div>
    </div>
    }
  </div>
  }
  @else {
  <mat-divider></mat-divider>
  <div class="section">
    {{'No warnings' | translate}}
  </div>
  }

  <div class="controls-wrapper">
    <div class="control-item">
      <mat-slide-toggle [checked]="followVehicle" (change)="changeFollowVehicle($event)">
        {{'Follow in map' | translate}}
      </mat-slide-toggle>
    </div>
    <div class="control-item">
      @if (canOpenStreetView) {
      <a mat-button color="primary" (click)="openVehicleInStreetView()">
        <i class="icon fa fa-solid fa-street-view"></i>
        {{'Street view' | translate}}
        <mat-icon class="smaller-icon">open_in_new</mat-icon>
      </a>
      }
    </div>
  </div>

  @if ((vehicle?.departureDeviation || vehicle?.arrivalDeviation)) {
  <app-vehicle-trip-info [vehicleActivity]="vehicleActivity$.value" [departureDeviation]="vehicle?.departureDeviation"
    [arrivalDeviation]="vehicle?.arrivalDeviation" [departureHistory]="departureHistory">
  </app-vehicle-trip-info>
  }
  @else {
  <div class="section highlight-background">
    {{'Not in traffic' | translate}}
  </div>
  }
</div>
}
@if (componentState?.selectedTab === 'vehicleinfo') {
<div class="properties">
  <div class="property">
    <div class="label">{{'Inventory number' | translate}}</div>
    <div class="value">{{vehicle?.inventoryNumberWithoutPrefix}}</div>
  </div>
  <div class="property">
    <div class="label">{{'Garage code' | translate}}</div>
    <div class="value">{{vehicle?.garageCode}}</div>
  </div>
  <div class="property">
    <div class="label">{{'Block' | translate}}</div>
    <div class="value">{{vehicle?.blockNumber}}</div>
  </div>
  <div class="property">
    <div class="label">{{'Route' | translate}}</div>
    <div class="value">{{vehicle?.routeNumber}}</div>
  </div>
  <div class="property">
    <div class="label">{{'Trip' | translate}}</div>
    <div class="value">{{vehicle?.tripNumber}}</div>
  </div>
  <mat-divider></mat-divider>
  <div class="property">
    <div class="label">{{'Longitude' | translate}}</div>
    <div class="value">{{vehicle?.position?.longitude}}</div>
  </div>
  <div class="property">
    <div class="label">{{'Latitude' | translate}}</div>
    <div class="value">{{vehicle?.position?.latitude}}</div>
  </div>
  <div class="property">
    <div class="label">{{'Bearing' | translate}}</div>
    @if (vehicle?.position?.bearing) {
    <div class="value">
      {{vehicle?.position?.bearing}} ° ({{vehicle.position?.bearingText}})
      <i class="icon-bearing fas fa-location-arrow fa-rotate-by"
        [ngStyle]="{'transform': 'rotate(' + (vehicle.position.bearing - 41) % 360 + 'deg)'}"></i>
    </div>
    }
  </div>
  <div class="property">
    <div class="label">{{'Speed' | translate}}</div>
    @if (vehicle?.position?.speed !== undefined) {
    <div class="value">
      <!-- Otherwise we will miss the case when speed = 0 -->
      <app-speed-dots [speed]="vehicle.position.speed"></app-speed-dots>
    </div>
    }
  </div>
  <div class="property">
    <div class="label">{{'Position timestamp' | translate}}</div>
    <div class="value">{{vehicle?.position?.timestamp | date:'yyyy-MM-dd HH:mm:ss'}}</div>
  </div>
  @if (vehicle?.stateOfCharge) {
  <mat-divider></mat-divider>
  <div class="property">
    <div class="label">{{'State of charge' | translate}}</div>
    <div class="value">{{vehicle?.stateOfCharge?.sensorValue}}%</div>
  </div>
  <div class="property">
    <div class="label">{{'State of charge timestamp' | translate}}</div>
    <div class="value">{{vehicle?.stateOfCharge?.measuredAt | date:'yyyy-MM-dd HH:mm:ss'}}</div>
  </div>
  }
  <mat-divider></mat-divider>
  <div class="property">
    <div class="label">{{'Departed from' | translate}}</div>
    <div class="value">{{vehicle?.departureDeviation?.stopName}}</div>
  </div>
  <div class="property">
    <div class="label">{{'Departure deviation' | translate}}</div>
    <div class="data">
      @if (vehicle.departureDeviation) {
      <app-deviation-text [deviation]="vehicle.departureDeviation"></app-deviation-text>
      }
    </div>
  </div>
  <div class="property">
    <div class="label">{{'Departure deviation timestamp' | translate}}</div>
    <div class="value">{{vehicle?.departureDeviation?.measuredAt | date:'yyyy-MM-dd HH:mm:ss'}}</div>
  </div>
  <div class="property">
    <div class="label">{{'Arrived to' | translate}}</div>
    <div class="value">{{vehicle?.arrivalDeviation?.stopName}}</div>
  </div>
  <div class="property">
    <div class="label">{{'Arrival deviation timestamp' | translate}}</div>
    <div class="value">{{vehicle?.arrivalDeviation?.measuredAt | date:'yyyy-MM-dd HH:mm:ss'}}</div>
  </div>
  <mat-divider></mat-divider>
  @for (warning of vehicle?.warnings; track trackByIndex($index, warning)) {
  <mat-divider></mat-divider>
  <div class="property">
    <div class="label">{{'Warning' | translate}}</div>
    <div class="value">{{warning?.measuredAt | date:'yyyy-MM-dd HH:mm:ss'}}</div>
  </div>
  <div class="property">
    <div class="value">
      <app-warning-icon [messageType]="warning.messageType"></app-warning-icon>
      {{ warning | formatWarningMessage }}
    </div>
  </div>
  }
</div>
}
@if (componentState?.selectedTab === 'debug') {
<div class="debug">
  <pre>{{vehicle | json}}</pre>
</div>
}
@if (componentState?.selectedTab === 'block') {
<app-vehicle-block-info [vehicleBlockActivities]="blockActivites" [vehicle]="vehicle"
  [drillInOutlet]="drillInOutlet"></app-vehicle-block-info>
}
@if (componentState?.selectedTab === 'soc') {
<div class="state-of-charge">
  @if (vehicle?.isElectric) {
  <div class="row">
    <div class="left-col">
      <h4 class="title">{{'State of charge' | translate}}</h4>
      <div class="value">{{'Measured at' | translate}} {{vehicle?.stateOfCharge?.measuredAt |
        date:'yyyy-MM-dd HH:mm:ss'}}</div>
    </div>
    <div class="right-col">
      <app-battery-status-info [batteryStatusInfo]="vehicle?.stateOfCharge"></app-battery-status-info>
    </div>
  </div>
  }
  @if (vehicle?.isElectric) {
  <h4 class="title with-padding">{{'Last 12 hour history and prognosis' | translate}}</h4>
  <app-state-of-charge-history [vehicleInventoryNumber]="vehicle?.inventoryNumber"></app-state-of-charge-history>
  }
</div>
}
@if (componentState?.selectedTab === 'signon') {
<div class="section-column">
  <div>
    <div class="label-tiny"> {{'Public transport authority' | translate}}</div>
  </div>
  <div>
    <div class="text-tiny"> {{ signonPrincipalLabel }} </div>
  </div>
</div>
<mat-divider role="separator" class="mat-divider mat-divider-horizontal" aria-orientation="horizontal"></mat-divider>
<div class="section signon-top-section">
  <div class="label-tiny">{{'Update realtime information' | translate}}</div>
  <button class="button secondary-button pointer-cursor"
    (click)="openPassengerInformation(vehicle.inventoryNumber)">{{'Traveler information' | translate}} <i
      class="fa fa-external-link"></i></button>

  @if (signOnUpdateStatus === 'ok') {
    <div class="alert-ok">
    <i class="fa-solid fa-circle-info"></i>
    <span>
      {{'Update sent' | translate}}<br>
    </span>
  </div>
  }

  @if (signOnUpdateStatus === 'error') {
  <div class="alert-error">
    <i class="fa-solid fa-circle-info"></i>
    <span>
      {{'Error' | translate}}<br>
      Signed Off: {{signOffStep.status}}<br>
      Signed On: {{signOnStep.status}}<br>
    </span>
  </div>
  }
  
  @if (currentAssignment && currentAssignment.state === AssignmentState.SignedOn) {
  <div class="signon-layout">
    <div class="signon-card">
      <div class="signon-card-header signon-card-header--stacked">
        <div class="text-x-small signon-heading">{{'Status' | translate}}&nbsp;{{ signonPrincipalLabel }} </div>
        <div class="signon-status-line">
          <span class="signon-pill">{{ currentAssignment.state === AssignmentState.SignedOn ? 'SIGNED ON' :
            currentAssignment.stateName }}</span>
          @if (currentAssignment.trafficDate) {
          <span class="text-tiny signon-traffic-date">{{ currentAssignment.trafficDate | date:'yyyy-MM-dd' }}</span>
          }
        </div>
      </div>

      <div class="signoff-row">
        <div class="custom-checkbox">
          <input name="signOff" type="checkbox" [checked]="signonForm.signOff ?? false"
            (change)="onSignonCheckboxChange('signOff', $event)" />
          <span class="focus-background"></span>
        </div>
        <div class="text-tiny signoff-row-label">Sign Off</div>
        <div class="journey-scope">
          @if (currentAssignment.routeName || currentAssignment.tripNumber) {
          <div class="route-info text-tiny">
            <div class="route">{{ currentAssignment.routeName }}</div>
            <div class="trip">{{ currentAssignment.tripNumber }}</div>
          </div>
          }
          @if (currentAssignment.plannedStartTime || currentAssignment.plannedEndTime) {
          <div class="text-tiny">{{ currentAssignment.plannedStartTime | slice:0:5 }}-{{
            currentAssignment.plannedEndTime | slice:0:5}}</div>
          }
          @if (currentAssignment.lineName) {
          <div class="text-tiny truncate-text">{{ currentAssignment.lineName }}</div>
          }
        </div>
      </div>
    </div>
  </div>
  }@else {
  <div class="signon-layout">
    <div class="signon-card">
      <div class="signon-card-header signon-card-header--stacked">
        <div class="text-x-small signon-heading">{{'Status' | translate}}&nbsp;{{ signonPrincipalLabel }} </div>
        <div class="signon-pill"> NOT ASSIGNED</div>
      </div>
    </div>
  </div>
  }

  <div class="signon-layout">
    <div class="signon-card">
      <div class="signon-card-header signon-card-header--stacked">
        <div class="text-x-small signon-heading">{{'SignOn on trip' | translate}}</div>
      </div>

      <div class="signon-row">
        <div class="custom-checkbox">
            <input 
                name="signOn"
                type="checkbox"
                [checked]="signonForm.signOn"
                (change)="onSignonCheckboxChange('signOn', $event)"
                />
          <span class="focus-background"></span>
        </div>

        <div class="text-tiny signon-row-label">Sign On</div>

        <div class="signon-fields">
          <div class="signon-input-row">
              <input 
                  name="vehicletaskno"
                  type="text"
                  class="text-tiny"
                  placeholder="Omlopp"
                  [(ngModel)]="signonForm.vehicletaskno"
                  readonly="true"
                  />

              <select 
                  name="trip"
                  class="text-tiny"
                  [(ngModel)]="signonForm.signOnItem.vehicleactivityid"
                  (change)="onTripChange()">
              <option value="">{{'Select trip' | translate}}</option>
              <option *ngFor="let trip of trips" [value]="trip.vehicleactivityid">
                {{ trip.route }} - {{ trip.tripNo }} ({{ trip.time }}) - {{ trip.designation }}
              </option>
            </select>
          </div>

          <div class="signon-input-row signon-input-row--full">
            <select name="stop" class="text-tiny" [(ngModel)]="signonForm.signOnItem.sequenceNumber">
              <option value="">{{'Select stop' | translate}}</option>
              <option *ngFor="let stop of stops" [value]="stop.sequenceNumber">
                {{ stop.name }} - ({{ stop.departureTime }})
              </option>
            </select>
          </div>
          @if (anotherVehicleIsSignedOn) {
          <div class="alert-info">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <span>
              Trip <strong> {{ selectedSignOnTrip?.tripNo }}</strong> {{'is already signedOn by vehicle' | translate}}
              <strong>{{ tripCurrentState?.vehicleId }} </strong>.
            </span>
          </div>
          }
        </div>
      </div>

    </div>
  </div>
  <div class="signon-submit-wrapper">
      <button name="update"
              type="button"
              class="button primary-button"
              [disabled]="!isSignonSubmitEnabled || isSubmittingSignOnUpdate"
              (click)="submitSignOnUpdate()">
          {{'Send update' | translate}}
      </button>
  </div>
</div>
}
}
@else {
<div class="wrapper">
  <places-spinner [small]="true"></places-spinner>
</div>
}
